import { useEffectOnce } from "react-use";
import { useNavigate } from "react-router-dom";

export const checkToken = (token) => {
    const navigate = useNavigate();

    useEffectOnce(() => {
        if (!token) {
            navigate('/login');
        }
    })  
}

export const checkLoggedIn = (token) => {
    const navigate = useNavigate();

    useEffectOnce(() => {
        if (token) {
            navigate('/');
        }
    })
}